module.exports = __webpack_public_path__ + "static/img03-a73e3b991b858cc0d131a27c5ae3f117.png";